import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Login from './login/login';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Report from './pages/Report';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import OrderRegister from './pages/Report/OrderRegister';
import DispatchRegister from './pages/Report/DispatchRegister';
import PackingRegister from './pages/Report/PackingRegister';
import Wire from './pages/Wire/Wire';
import WirePurchase from './pages/Wire/WirePurchase';
import WireStockAdjustment from './pages/Wire/WireStockAdjustment';
import Register from './pages/Report/Register';
import OrderCardEntry from './pages/OrderEntry';
import PackingEntry from './pages/PackingEntry';
import DispatchEntry from './pages/DispatchEntry';
import DispatchPDF from './pages/DispatchPdf';
import OrderPDF from './pages/OrderPdf';
import PackagePDF from './pages/Packagepdf';
import PackingEntryView from './pages/PackingView';
import Pdimenu from './pages/products/Pdimenu';
import Fdiform from './pages/products/FDIform';
import Fdimenu from './pages/products/Fdimenu';
import FdiFormPdf from './pages/products/Fdipdf';
import PdiFormpdf from './pages/products/Pdipdf';
import DailyProductionform from './pages/products/dailyReportform';
import DailyReportMenu from "./pages/products/dailyReportmenu";
import ProtectedRoute from "./components/ProtectedRoute";

const appRouter = createBrowserRouter([
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> },
  { path: "/dashboard", element: <Dashboard /> },

  {
    path: "order-entry",
    element: <ProtectedRoute element={<OrderCardEntry />} allowedRoles={["superadmin", "admin", "user"]} />
  },

  {
    path: "dispatch-entry",
    element: <ProtectedRoute element={<DispatchEntry />} allowedRoles={["superadmin", "admin"]} />
  },

  {
    path: "packing-entry",
    element: <ProtectedRoute element={<PackingEntry />} allowedRoles={["superadmin", "admin", "packer", "user"]} />
  },

  {
    path: "admin",
    element: <ProtectedRoute element={<Admin />} allowedRoles={["superadmin"]} />
  },

  {
    path: "report",
    element: <ProtectedRoute element={<Report />} allowedRoles={["superadmin"]} />
  },

  {
    path: "report/register",
    element: <ProtectedRoute element={<Register />} allowedRoles={["superadmin"]} />
  },

  {
    path: "report/order-register",
    element: <ProtectedRoute element={<OrderRegister />} allowedRoles={["superadmin"]} />
  },

  {
    path: "report/dispatch-register",
    element: <ProtectedRoute element={<DispatchRegister />} allowedRoles={["superadmin"]} />
  },

  {
    path: "report/packing-register",
    element: <ProtectedRoute element={<PackingRegister />} allowedRoles={["superadmin"]} />
  },

  {
    path: "wire/wire",
    element: <ProtectedRoute element={<Wire />} allowedRoles={["superadmin", "admin", "user"]} />
  },

  {
    path: "wire/wire-purchase",
    element: <ProtectedRoute element={<WirePurchase />} allowedRoles={["superadmin", "admin", "user"]} />
  },

  {
    path: "wire/wire-stock-adjustment",
    element: <ProtectedRoute element={<WireStockAdjustment />} allowedRoles={["superadmin"]} />
  },

  {
    path: "dispatchpdf",
    element: <ProtectedRoute element={<DispatchPDF />} allowedRoles={["superadmin", "admin"]} />
  },

  {
    path: "orderpdf",
    element: <ProtectedRoute element={<OrderPDF />} allowedRoles={["superadmin", "admin", "user"]} />
  },

  {
    path: "packagepdf",
    element: <ProtectedRoute element={<PackagePDF />} allowedRoles={["superadmin", "admin"]} />
  },

  {
    path: "verifypackage/:vnum",
    element: <ProtectedRoute element={<PackingEntryView />} allowedRoles={["superadmin", "admin", "packer"]} />
  },

  {
    path: "pdimenu",
    element: <ProtectedRoute element={<Pdimenu />} allowedRoles={["superadmin", "admin", "qc"]} />
  },

  {
    path: "pdiform",
    element: <ProtectedRoute element={<PdiFormpdf />} allowedRoles={["superadmin", "admin", "qc"]} />
  },

  {
    path: "fdiform",
    element: <ProtectedRoute element={<Fdiform />} allowedRoles={["superadmin", "admin", "qc"]} />
  },

  {
    path: "fdimenu",
    element: <ProtectedRoute element={<Fdimenu />} allowedRoles={["superadmin", "admin", "qc"]} />
  },

  {
    path: "fdipdf",
    element: <ProtectedRoute disableprotection={true} element={<FdiFormPdf />} allowedRoles={["superadmin", "admin", "qc"]} />
  },

  {
    path: "dailyproductionreport",
    element: <ProtectedRoute element={<DailyProductionform />} allowedRoles={["superadmin", "admin", "qc"]} />
  },

  {
    path: "dailyproductionmenu",
    element: <ProtectedRoute element={<DailyReportMenu />} allowedRoles={["superadmin", "admin", "qc"]} />
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={appRouter} />
  </React.StrictMode>
);
